import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconProfile: React.FC<SvgIconProps> = (props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      color: COLORS.CERULEAN,
    }}
    {...props}
  >
    <path 
        d="M12.09 10.94C14.56 10.94 16.56 8.94 16.56 6.47C16.56 4 14.56 2 12.09 2C9.62 2 7.62 4 7.62 6.47C7.62 8.94 9.62 10.94 12.09 10.94ZM12.09 3.76C13.56 3.76 14.8 5 14.8 6.47C14.8 7.94 13.56 9.18 12.09 9.18C10.62 9.18 9.38 7.95 9.38 6.47C9.38 4.99 10.62 3.76 12.09 3.76Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M20.97 17.94C19.32 15.06 16.03 12.82 12.09 12.82C8.14999 12.82 4.90999 15.05 3.20999 17.94C2.14999 19.76 3.44999 22 5.55999 22H18.62C20.74 22 22.03 19.76 20.97 17.94ZM19.32 19.7C19.26 19.82 19.03 20.11 18.61 20.11H5.55999C5.14999 20.11 4.96999 19.87 4.84999 19.7C4.78999 19.58 4.60999 19.23 4.84999 18.88C6.31999 16.35 9.13999 14.76 12.03 14.76C14.92 14.76 17.79 16.41 19.21 18.88C19.5 19.23 19.39 19.59 19.33 19.7H19.32Z" 
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)
